export const locale = {
  lang: "en",
  data: {
    CART_LIST_CUST: {
      HEADER: "Cart List",
      CART_DTL: "Cart Information",
      CART_SUM: "Cart Summary",
      NO: "No",
      REWARD: "Reward",
      POINT: "Point",
      DECREASE: "Decrease",
      QUANTITY: "Quantity",
      INCREASE: "Increase",
      TOTAL_POINT: "Total Point",
      TOTAL_REQUIRED_POINT: "Total Required Points",
      TOTAL_ITEM: "Total Reward Items",
      REDEEM_REQ: "Redeem Request",
      REDEEM_NOW: "Redeem Now",
      ERROR_REDEEM: "*You don't have enough point to redeem",
      ERROR_EMPTY_REDEEM: "*Add some rewards to cart to redeem",
      DATA_NOT_FOUND: "Data Not Found ...",
    },
  },
};
